import { render } from "./AssistClientReportCreation.vue?vue&type=template&id=6c138a01"
import script from "./AssistClientReportCreation.vue?vue&type=script&lang=js"
export * from "./AssistClientReportCreation.vue?vue&type=script&lang=js"

import "./AssistClientReportCreation.vue?vue&type=style&index=0&id=6c138a01&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__